import { cssColorValue, cssSpacing, isSpacer } from "../../styles/index.mjs";
import styled, { css } from "../../styled-components.mjs";
export var TextElement = styled.span.withConfig({
  displayName: "Text__TextElement",
  componentId: "sc-if376j-0"
})(["margin-block-start:0;margin-block-end:0;", ";", ""], function (props) {
  return props.$paddingBottom && css(["padding-block-end:", ";"], isSpacer(props.$paddingBottom) ? cssSpacing(props.$paddingBottom) : props.$paddingBottom);
}, function (props) {
  return props.$semanticColor ? css(["color:", ";"], cssColorValue(props.$semanticColor)) : css(["color:inherit;"]);
});